import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { ArrowDb } from '../redux/arrowDbSlice';

const useArrowDbsInSheet = (sheetId: string | null) : [string[], ArrowDb[]] => {
  const arrowDb = useSelector((state: RootState) => state.arrowDb);
  const ids = Object.keys(arrowDb.arrows).filter(id => arrowDb.arrows[id].sheetId === sheetId);
  const arrows = ids.map(id => arrowDb.arrows[id]);
  return [ids, arrows];
}

export default useArrowDbsInSheet;
